import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Container, Spinner } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import Turnstile from 'react-turnstile';
import './Login.css';

const API_URL = process.env.REACT_APP_API_URL;
const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY; 
const LOGIN_URL = '/login'; 

const Signup = () => {
  const [form, setForm] = useState({ email: '', password: '', display_name: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false); 

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleTogglePassword = () => {
    setShowPassword(prev => !prev);
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setError(false);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(form.email);

    if (!form.email || !isValidEmail || !form.password || !form.display_name || !turnstileToken) {
      setError(true);
      return;
    }

    setIsSubmitting(true); // show spinner

    try {
      const response = await fetch(`${API_URL}/auth/signup`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...form, turnstileToken }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Signup failed');
      }

      toast.success(data.message || 'Signup successful! 🎉');

      setTimeout(() => {
        window.location.href = LOGIN_URL;
      }, 2000);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container>
      <ToastContainer />
      <div className="home-page-wrapper">
        <div className="login-container">
          <div className="headline d-flex justify-content-between align-items-center">
            <h2>Join the community</h2>
          </div>
          <div className="portal-description">
            <p>Ready to create something brilliant? Let’s get you set up.</p>

            <form onSubmit={handleSignup} noValidate>
              <div className="input-wrapper">
                <label htmlFor="display_name" className="input-label">Name</label>
                <input
                  id="display_name"
                  type="text"
                  name="display_name"
                  placeholder="Your name"
                  value={form.display_name}
                  onChange={handleChange}
                  className={`input-control ${error && !form.display_name ? 'error' : ''}`}
                  required
                  disabled={isSubmitting}
                />
                {error && !form.display_name && (
                  <span className="input-error">Please enter your name</span>
                )}
              </div>

              <div className="input-wrapper">
                <label htmlFor="email" className="input-label">Email</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  value={form.email}
                  onChange={handleChange}
                  className={`input-control ${error && !form.email ? 'error' : ''}`}
                  required
                  disabled={isSubmitting}
                />
                {error && (!form.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) && (
                  <span className="input-error">Please enter a valid email</span>
                )}
              </div>

              <div className="input-wrapper">
                <label htmlFor="password" className="input-label">Password</label>
                <div style={{ position: 'relative' }}>
                  <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    placeholder="Create a password"
                    value={form.password}
                    onChange={handleChange}
                    className={`input-control ${error && !form.password ? 'error' : ''}`}
                    required
                    disabled={isSubmitting}
                  />
                  <span
                    onClick={handleTogglePassword}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                      color: 'var(--text-color-light)',
                      fontSize: '0.9rem',
                      userSelect: 'none'
                    }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                {error && !form.password && (
                  <span className="input-error">Please enter your password</span>
                )}
              </div>

              <div className="input-wrapper">
                <label className="input-label">Verify you're human</label>
                <Turnstile
                  sitekey={TURNSTILE_SITE_KEY}
                  onVerify={(token) => setTurnstileToken(token)}
                  className="turnstile-wrapper"
                />
                {error && !turnstileToken && (
                  <span className="input-error">Please complete the CAPTCHA</span>
                )}
              </div>

              <button
                type="submit"
                className="btn btn-primary w-100 mb-3 d-flex align-items-center justify-content-center"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Signing up...
                  </>
                ) : (
                  'Sign Up'
                )}
              </button>

              <p className="mt-3">Already have an account? <a href="/login">Sign in here</a></p>
            </form>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Signup;
